<template>
  <div>
    <div class="row mt-2">
      <div class="col-12 d-flex">
        <i class="fas fa-file-chart-line text-orange mr-2 mt-1"></i>
        <p class="font-weight-normal font-18">
          Métricas de Participación
        </p>
      </div>
    </div>
    <div class="row">
      <time-line class="mt-2 w-95">
        <time-line-item
          v-for="(history, i) of records"
          :key="i"
          icon="fas fa-file"
          class="p-2"
        >
          <template #date>
            <span class="color-secondary-6 font-12 ml-5">Fecha:</span>
            <p class="color-black font-15 font-weight-bold">
              {{ history.createdDate | dateTime }}
            </p>
          </template>

          <div id="main-info" class="row ml-2">
            <div class="col-12 col-md-4 font-weight-bold">
              <div class="color-secondary-6 font-14">
                Evento:
              </div>
              <div class="color-gray-12 font-18 font-weight-bold">
                {{ history.event | empty }}
              </div>
            </div>

            <div class="col-12 col-md-4 ">
              <div class="color-secondary-6 font-14">
                Nombre del Usuario:
              </div>
              <div class="color-black font-16 font-weight-normal">
                {{ history.participantFullName | capitalize }}
              </div>
            </div>

            <div class="col-12 col-md-4">
              <div class="color-secondary-6 font-14">
                Descripción:
              </div>
              <div class="color-black font-16 font-weight-normal">
                {{ history.comment | empty }}
              </div>
            </div>
          </div>
        </time-line-item>
      </time-line>

      <div
        v-if="currentPage !== totalPages"
        class="d-flex justify-content-center align-items-center"
      >
        <action-button
          class="btn-see-more"
          i="fas fa-chevron-down"
          variant="outline-success rounded-pill"
          @click="loadMore"
        >
          Ver más
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import { TimeLine, TimeLineItem } from '@/components/common/timeline';
import { getWorkshopParticipantLogs } from '@/services/operations/dashboard-management';

export default {
  name: 'Metrics',
  components: {
    ActionButton,
    CustomInput,
    TimeLine,
    TimeLineItem,
  },
  props: {
    participantId: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({
    records: [],
    currentPage: 1,
    totalPages: 0,
  }),
  async created() {
    await this.initTrackingHistory();
  },
  methods: {
    async initTrackingHistory() {
      this.records = await this.getWorkshopParticipantLogNextPage(1);
    },

    async getWorkshopParticipantLogNextPage(currentPage) {
      const payload = {
        participantId: this.participantId,
        currentPage,
        pageSize: 5,
      };
      try {
        const { data } = await getWorkshopParticipantLogs(payload);
        this.totalPages = data.pageCount;
        this.currentPage = data.currentPage;
        return [...data.data];
      } catch (err) {
        this.Toast(
          'Alerta',
          err.response.data.message || 'error',
          'error',
          5000
        );
        return [];
      }
    },
    async loadMore() {
      const nextPage = Number(this.currentPage) + 1;
      const { data } = await this.getWorkshopParticipantLogNextPage(nextPage);
      this.records.concat(data);
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 767.98px) {
  ::v-deep(.timeline__content) {
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    min-width: 200px;
  }
}
</style>
